// extracted by mini-css-extract-plugin
export default {"description":"description-t6JLp","inlineLoader":"inlineLoader-iLWGe"};